angular.module('capability-ng-user-app').config(function($httpProvider: ng.IHttpProvider) {
  $httpProvider.interceptors.push(function(ngAccountDatasource, updateExpireTimeCommand) {
    // TODO pull this regex into utility-ts-types
    const IS_RESOURCE_REQUEST = /\.\w{3,4}$/i;
    return {
      response: function(response: ng.IHttpPromiseCallbackArg<any>) {
        const hasExtension = IS_RESOURCE_REQUEST.test(response.config!.url);
        const isAnAPIRequest = !hasExtension;
        if (ngAccountDatasource.isSessionOpen() && isAnAPIRequest) {
          updateExpireTimeCommand();
        }
        return response;
      }
    };
  });
});



// WEBPACK FOOTER //
// ./app/lib/user_app/configuration/session_expire_update_interceptor.ts